"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategorySubscriptionStatus = getCategorySubscriptionStatus;
exports.getSubscriptionStatus = getSubscriptionStatus;
exports.subscribeCategory = subscribeCategory;
exports.subscribeTopic = subscribeTopic;
exports.unsubscribeCategory = unsubscribeCategory;
exports.unsubscribeTopic = unsubscribeTopic;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function getSubscriptionStatus(_x) {
  return _getSubscriptionStatus.apply(this, arguments);
}

function _getSubscriptionStatus() {
  _getSubscriptionStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(publicId) {
    var _yield$axios$get, subscribed;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get("/subscribers/topic/".concat(publicId));

          case 2:
            _yield$axios$get = _context.sent;
            subscribed = _yield$axios$get.data.subscribed;
            return _context.abrupt("return", subscribed);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getSubscriptionStatus.apply(this, arguments);
}

function subscribeTopic(_x2) {
  return _subscribeTopic.apply(this, arguments);
}

function _subscribeTopic() {
  _subscribeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(publicId) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post("/subscribers/topic/".concat(publicId));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _subscribeTopic.apply(this, arguments);
}

function unsubscribeTopic(_x3) {
  return _unsubscribeTopic.apply(this, arguments);
}

function _unsubscribeTopic() {
  _unsubscribeTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(publicId) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.delete("/subscribers/topic/".concat(publicId));

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _unsubscribeTopic.apply(this, arguments);
}

function getCategorySubscriptionStatus(_x4) {
  return _getCategorySubscriptionStatus.apply(this, arguments);
}

function _getCategorySubscriptionStatus() {
  _getCategorySubscriptionStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(categoryId) {
    var _yield$axios$get2, subscribed;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.get("/subscribers/subforum/".concat(categoryId));

          case 2:
            _yield$axios$get2 = _context4.sent;
            subscribed = _yield$axios$get2.data.subscribed;
            return _context4.abrupt("return", subscribed);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getCategorySubscriptionStatus.apply(this, arguments);
}

function subscribeCategory(_x5) {
  return _subscribeCategory.apply(this, arguments);
}

function _subscribeCategory() {
  _subscribeCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(categoryId) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post("/subscribers/subforum/".concat(categoryId));

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _subscribeCategory.apply(this, arguments);
}

function unsubscribeCategory(_x6) {
  return _unsubscribeCategory.apply(this, arguments);
}

function _unsubscribeCategory() {
  _unsubscribeCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(categoryId) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.delete("/subscribers/subforum/".concat(categoryId));

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _unsubscribeCategory.apply(this, arguments);
}